import { ajax } from '@/utils/request';
const api = {
    // 材料总计划
    getMasterPlan(data: any) {
        return ajax({
            method: 'get',
            url: `material-total-plan-mgt/plan-page`,
            data
        })
    },

    // 获取项目列表
    getProjectList(){
        return ajax({
            method: 'get',
            url: `project-mgt/select-project-list`,
        })
    },

    // 获取材料信息分页列表
    getMaterialsPaging(data:any) {
        return ajax({
            method: 'get',
            url: `material-mgt/materials`,
            data
        })
    },

    // 材料分类树
    getMaterialClass(data: any) {
        return ajax({
            method: 'get',
            url: `material-mgt/classifies`,
        })
    },

    // 获取项目启动会议详情
    getProjectStartMeetingDetail(projectCode:any){
        return ajax({
            method: 'get',
            url: `project-start-meeting/get/${projectCode}`,
        })
    },
    // 项目启动会议登记
    registerProjectStartMeeting(data: any){
        return ajax({
            method: 'post',
            url: `project-start-meeting/save`,
            data
        })
    },

    // 样板施工列表
    sampleConstructionList(data: any){
        return ajax({
            method: 'get',
            url: `model-contruction/list`,
            data
        })
    },
    // 样板施工取消确认
    cancelSampleConstruction(recordId:any){
        return ajax({
            method: 'post',
            url: `model-contruction/cancel-confirm/${recordId}`,
        })
    },
    // 样板施工确认
    confirmSampleConstruction(data:any){
        return ajax({
            method: 'post',
            url: `model-contruction/confirm`,
            data
        })
    },
    // 样板施工登记
    registerConstruction(data:any){
        return ajax({
            method: 'post',
            url: `model-contruction/create`,
            data
        })
    },
    // 样板施工详情
    sampleConstructionDetail(recordId:any){
        return ajax({
            method: 'get',
            url: `model-contruction/get/${recordId}`,
        })
    },
    // 样板施工移除
    deleSampleConstruction(recordId:any){
        return ajax({
            method: 'post',
            url: `model-contruction/remove/${recordId}`,
        })
    },
    // 样板施工修改
    sampleConstructionUpdate(data:any){
        return ajax({
            method: 'post',
            url: `model-contruction/update`,
            data
        })
    },
    // 导出材料样板
    sampleConstructionExportMaterial(data:any){
        return ajax({
            method: 'get',
            url: `model-contruction/export-material`,
            data,
            type: 'blob',
        })
    },
    // 导出施工样板
    sampleConstructionExportConstruction(data:any){
        return ajax({
            method: 'get',
            url: `model-contruction/export-construction`,
            data,
            type: 'blob',
        })
    },
    // 乙方付款台账
    getSecondBillList(data:any){
        return ajax({
            method: 'get',
            url: `second-bill-mgt/second-bill`,
            data
        })
    },
    // 项目班组劳务树
    getProjiectLabourLists(id:any){
        return ajax({
            method: 'get',
            url: `sign-mgt/project-labour/${id}`,
        })
    }, 
    // 打卡记录分页查询
    getSignPageList(data:any){
        return ajax({
            method: 'get',
            url: `sign-mgt/sign-page`,
            data
        })
    },
    // 导出列表
    exportSign(data:any){
        return ajax({
            method: 'get',
            url: `sign-mgt/sign/export`,
            data,
            type: 'blob',
        })
    },
    // 乙方付款台账-劳务付款明细
    secondBillLabour(data:any){
        return ajax({
            method: 'get',
            url: `second-bill-mgt/labour-payment-paid-detail`,
            data
        })
    },
    // 乙方付款台账-双包付款明细
    secondBillMaterial(data:any){
        return ajax({
            method: 'get',
            url: `second-bill-mgt/double-payment-paid-detail`,
            data
        })
    },
    // 报表管理-项目收支统计
    // 分页
    engineeringReportInAndOutPage(data:any){
        return ajax({
            method: 'get',
            url: `report/project-statistics-page`,
            data
        })
    },
    // 填报进度产值
    engineeringReportInAndOutFill(data:any){
        return ajax({
            method: 'put',
            url: `report/project-process-amount/${data.projectId}?processAmount=${data.processAmount}`,
        })
    },
    // 统计
    engineeringReportInAndOutSummary(data:any){
        return ajax({
            method: 'get',
            url: `report/project-statistics-sum`,
            data
        })
    },
    // 导出
    engineeringReportInAndOutExport(data:any){
        return ajax({
            method: 'get',
            url: `report/project-statistics-export`,
            data,
            type: 'blob',
        })
    },
    // 报表管理-项目工程任务单
    // 分页
    engineeringRreportTaskPage(data:any){
        return ajax({
            method: 'get',
            url: `report/project-task-page`,
            data
        })
    },
    // 导出
    engineeringRreportTaskExport(data:any){
        return ajax({
            method: 'get',
            url: `report/project-task-export`,
            data,
            type: 'blob',
        })
    },
}

export default api;